// extracted by mini-css-extract-plugin
export default {"container":"list_container__DqeOh","title":"list_title__vR4ry","button":"list_button__4N34+","list-container":"list_list-container__xWFMy"};